/**
 * 新学员培训根据选择的任职进行初始化
 * @Author:wuTao
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, utils_tool, component_tool } from '@/tool'
import { modelUtils } from "@/utils";
const { WizModal } = component_tool
import { WizTableForm } from '@/containers/common';

let {
  WizContainer, ossFileUtils
} = framework_tool;

class InitDealerNewPersonTrainDetail extends WizContainer {
  componentName = 'InitDealerNewPersonTrainDetail';

  constructor(props) {
    super(props);
    this.state = {
      addClassStudentVisible: false,
      orgId:null,
      value: undefined
    };
  }

  _componentDidMount = () => {

  }

  //选择人员弹出框确定按钮事件
  _initDealerNewPersonTrainDetail = (e,data) => {
    let obj = this.state.value;
    if (obj && obj instanceof Array && obj.length > 0) {
      let userIdentityId = null;
      let userName_ = null;
      let fullName_ = null;
      let positionName_ = null;
      let orgName_ = null;
      obj.forEach(key => {
        let student={};
        const {personId,orgId,positionId,userName,fullName, id,orgName,positionName} = key;
        if (!id){
          wizNotice.warn('学员账号【'+userName_+'】,姓名【'+fullName_+'】任职【'+orgName_+'-'+positionName_+'】无效，请确认后重试');
          return;
        }
        userIdentityId = id;
        userName_= userName;
        fullName_= fullName;
        positionName_ = positionName;
        orgName_ = orgName;
      });
      this._handleConform(
        '确认初始化：学员账号【'+userName_+'】,姓名【'+fullName_+'】任职【'+orgName_+'-'+positionName_+'】的培训数据，初始化后无法取消，请谨慎操作！',
        () => this._initRequirementOrgPersonByUserIdentityId(userIdentityId),
        { okText: '确认' }
      )
    }else{
      this.props.changeModal(false);
    }
  };

  _initRequirementOrgPersonByUserIdentityId = (userIdentityId) => {
    this.doAction({
      path: 'requirementOrgPerson/initRequirementOrgPersonByUserIdentityId',
      payload: {
        key: 'requirementOrgPerson@initRequirementOrgPersonByUserIdentityId',
        apiParams: {
          userIdentityId
        }
      },
    })
    this.props.changeModal(false);
  }

  _handleConform = (content, onOk, other) => {
    WizModal.confirm({
      content,
      onOk,
      ...other,
    })
  }

  _onCancel= (e) =>{
    this.props.changeModal(false);
  };

  setFileData(nextKeys, nextRows) {
    this.setState({
      value: nextKeys
    })
  }

  _render() {

    const {orgId} = this.props;
    let userIdentityConfig = WizTableForm.Config.userIdentity(this, { apiParams: { jobState: 1, disabled: 0, orgId: orgId, isNotAuth: true,isNotShowOrganization: true } });
    let tableFormProps = {
      title: '选择学员',
      showModal:false,
      visible:false,
      showSelectValue: true,
      showSelect:true,
      selectType: 'radio',
      initRows: [],
      value: [],
    };


    return <WizTableForm
      {...userIdentityConfig} {...tableFormProps}
     // onSubmit={this._addClassStudentSubmit}
      onSelectedRows={this.setFileData.bind(this)}
    />
  }
}

const mapStateToProps = (state, ownProps) => {

  return {
  }
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(InitDealerNewPersonTrainDetail);
